import type { FormEvent } from "react"
import { Button } from "@/shared/ui/Button"
import { FormField, SelectField } from "@/shared/ui/FormField"
import { UFS } from "@/shared/lib/brazil"
import { formatPostalCode } from "@/shared/lib/postalCode"
import type { NetworkFilters } from "@/features/network/useNetworkSearch"

export interface NetworkSearchFormProps {
  filters: NetworkFilters
  onChange: (filters: NetworkFilters) => void
  onSubmit: () => void
  loading: boolean
  error: string
}

export function NetworkSearchForm({ filters, onChange, onSubmit, loading, error }: NetworkSearchFormProps) {
  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()
    onSubmit()
  }

  const update = (patch: Partial<NetworkFilters>) => onChange({ ...filters, ...patch })

  return (
    <div className="bg-off-white rounded-2xl p-6 mb-8 border border-verde-profundo/8">
      <form onSubmit={handleSubmit} noValidate>
        <div className="grid sm:grid-cols-2 gap-4 mb-5">
          <FormField
            label="CEP"
            id="rede-cep"
            placeholder="00000-000"
            value={filters.postalCode}
            onChange={(event) => update({ postalCode: formatPostalCode(event.target.value) })}
            maxLength={9}
            inputMode="numeric"
            autoComplete="postal-code"
          />

          <SelectField
            label="Estado"
            id="rede-estado"
            value={filters.state}
            onChange={(event) => update({ state: event.target.value })}
          >
            <option value="">Selecione</option>
            {UFS.map((uf) => (
              <option key={uf} value={uf}>
                {uf}
              </option>
            ))}
          </SelectField>

          <FormField
            label="Cidade"
            id="rede-cidade"
            placeholder="Nome da cidade"
            value={filters.city}
            onChange={(event) => update({ city: event.target.value })}
          />
        </div>

        {error && (
          <p className="text-sm text-red-600 mb-4" role="alert">
            {error}
          </p>
        )}

        <Button variant="primary" size="md" type="submit" loading={loading}>
          Consultar rede
        </Button>
      </form>
    </div>
  )
}
